import styled from '@emotion/styled';
import { css } from '@emotion/core';
import AutosizeInput from 'react-input-autosize';

export const editableTextPaddingNormal = 7;
export const editableTextPaddingDense = 5;

export const underlineDottedStyling = ({ error = false }) => css`
  background-color: transparent;
  background-image: repeating-linear-gradient(
    to right,
    var(--color-border-dark) 0 5px,
    transparent 5px 10px
  );
  background-size: 100% 1px;
  background-position: left bottom;
  background-repeat: no-repeat;

  &:hover:not([disabled]) {
    background-image: repeating-linear-gradient(
      to right,
      var(--color-button-secondary-hover) 0 5px,
      transparent 5px 10px
    );
  }
  &:focus,
  &:focus:hover {
    background-image: linear-gradient(
      var(--color-button-secondary-hover),
      var(--color-button-secondary-hover)
    );
  }

  ${error
    ? css`
        &:not(:focus),
        &:hover:not([disabled]):not(:focus) {
          background-image: linear-gradient(
            var(--color-feedback-error),
            var(--color-feedback-error)
          );
        }
      `
    : ''}

  &[disabled] {
    background-image: none;
  }
`;

export const StyledInput = styled(AutosizeInput)`
  & > input {
    font-family: 'Proxima Nova', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    letter-spacing: -0.00125em;
    color: var(--color-font-primary);
    min-width: 40px;
    flex-grow: 1;
    outline: none;
    border: none;
    border: 0;
    border-radius: 0;

    ${underlineDottedStyling}

    ${({ compactAlignment }) =>
      compactAlignment
        ? css`
            padding-bottom: 1px;
          `
        : css`
            padding-bottom: ${editableTextPaddingNormal}px;
          `}

    ${({ sizing }) =>
      sizing === 'dense' &&
      css`
        padding: 0;
        padding-bottom: ${editableTextPaddingDense}px;
      `}

    // Naturally truncate if the container is sized
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    &[disabled] {
      background-color: var(--color-background-light);
    }

    &::placeholder {
      color: var(--color-font-placeholder);

      &[disabled] {
        color: var(--color-background-medium);
      }
    }

    // prevent bug in Chrome.
    // When we have an empty input in the drop list and we drag an element over it
    ${(props) =>
      !props.value &&
      css`
        color: var(--color-font-placeholder);
      `}
  }
`;
